import { render, staticRenderFns } from "./update-centre.vue?vue&type=template&id=1d5fdd51"
import script from "./update-centre.vue?vue&type=script&lang=js"
export * from "./update-centre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports